let inp = document.getElementsByClassName("FormFileUpload__Input");

for (let i = 0; i < inp.length; i++) {
  var allFilesInput = initializeHiddenAllFilesInput(inp[i]);
  var uploadButton = initializeUploadButton(inp[i]);
  updateFileList(inp[i], uploadButton, allFilesInput, getFiles(allFilesInput));

  inp[i].hidden = true;
  inp[i].addEventListener("change", (e) => {
    renderFiles(
      "FormFileUpload__Input",
      "FormFileUpload__Input_All_Files",
      i,
      "FormFileUpload__UploadButton"
    );
  });
}

function renderFiles(fileInputName, allFilesListInputName, index, uploadButtonName) {
  const fileInput = document.getElementsByClassName(fileInputName)[index];
  const allFilesListInput = document.getElementsByClassName(allFilesListInputName)[index];
  const uploadButton = document.getElementsByClassName(uploadButtonName)[index];

  const files = getFiles(allFilesListInput);
  const newFiles = getFiles(fileInput);

  if (fileInput.multiple) {
    files.push(...newFiles);
  } else {
    files.splice(0);
    files.push(...newFiles);
  }

  setFiles(allFilesListInput, files);

  updateFileList(fileInput, uploadButton, allFilesListInput, files);
  setFiles(fileInput, files);
}

function getFiles(input) {
  const files = new Array(input.files.length);

  for (let i = 0; i < input.files.length; i++) {
    files[i] = input.files.item(i);
  }
  return files;
}

function setFiles(input, files) {
  const dataTransfer = new DataTransfer();
  for (const file of files) {
    dataTransfer.items.add(file);
  }

  input.files = dataTransfer.files;
}

function addListElement(ul, uploadedFilesDiv, input, allFilesInput, j, files) {
  let li = document.createElement("li");
  li.innerHTML = allFilesInput.files.item(j).name;
  var deleteButton = document.createElement("span");
  deleteButton.innerText = "X";
  deleteButton.className = "fileList-delete-button";
  deleteButton.addEventListener("click", (e) => {
    files.splice(files.indexOf(allFilesInput.files.item(j)), 1);
    setFiles(allFilesInput, files);
    setFiles(input, files);
    ul.removeChild(li);
    if (files.length === 0) {
      uploadedFilesDiv.parentElement.removeChild(uploadedFilesDiv);
    }
  });
  li.appendChild(deleteButton);
  ul.appendChild(li);
}

function updateFileList(input, uploadButton, allFilesInput, files) {
  let nextSib = uploadButton.nextElementSibling;
  if (nextSib && nextSib.className === "uploadedFiles") {
    nextSib.remove();
  }

  if (files.length > 0) {
    let uploadedFilesDiv = document.createElement("div");
    uploadedFilesDiv.className = "uploadedFiles";
    let titleSpan = document.createElement("span");
    titleSpan.innerText = "Opplastede filer:";
    let ul = document.createElement("ul");
    uploadButton.insertAdjacentElement("afterend", uploadedFilesDiv);
    uploadedFilesDiv.appendChild(titleSpan);
    titleSpan.insertAdjacentElement("afterend", ul);

    for (var j = 0; j < allFilesInput.files.length; ++j) {
      addListElement(ul, uploadedFilesDiv, input, allFilesInput, j, files);
    }
  }
}

function initializeHiddenAllFilesInput(input) {
  var newInput = document.createElement("input");
  newInput.type = "file";
  newInput.className = "FormFileUpload__Input_All_Files";
  newInput.hidden = true;
  newInput.multiple = true;
  input.parentElement.appendChild(newInput);
  setFiles(newInput, input.files);
  return newInput;
}

function initializeUploadButton(input) {
  var newUploadButton = document.createElement("input");
  newUploadButton.type = "button";
  newUploadButton.className = "FormFileUpload__UploadButton";
  newUploadButton.value = lufLanguages.uploadButtonText;
  newUploadButton.onclick = function () {
    document.getElementById(input.id).click();
    return false;
  };
  input.parentElement.appendChild(newUploadButton);
  setFiles(newUploadButton, input.files);
  return newUploadButton;
}
